module.exports = __webpack_public_path__ + "img/banner-climate-actions.84b0c2a7.png";